/**
 *  Tab script file
**/

export default {
  name: 'Tab',
  mixins: [],
  components: {},
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    badge: {
      type: [String, Number],
      required: false
    },
    badgeIcon: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
  },
  mounted () {
    this.isActive = this.selected
  },
  methods: {
  },
  watch: {
    selected (value) {
      this.isActive = value
    }
  }
}
